import { createSlice } from "@reduxjs/toolkit";

const consultarpagosState = {
  dataconsultarpagos: []
}

export const consultarpagosSlice = createSlice({
  name: "consultarpagos",
  initialState: consultarpagosState,
  reducers: {
    StoreConsultarPagosData: (state, actions) => {
      state.dataconsultarpagos = actions.payload;
    },
    ResetConsultarPagosData: () => consultarpagosState,
  }
});

export const { StoreConsultarPagosData, ResetConsultarPagosData } = consultarpagosSlice.actions;

export default consultarpagosSlice.reducer;